(() => {
  if (window.__homeguardCartProtectionBound) return;
  window.__homeguardCartProtectionBound = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const button = target ? target.closest('[data-cart-protection-add]') : null;
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const wrapper = button.closest('.hg-cart-protection__form');
    const errorNode = wrapper ? wrapper.querySelector('.hg-cart-protection__error') : null;
    const label = button.querySelector('.hg-cart-protection__button-label');
    const spinner = button.querySelector('.hg-cart-protection__spinner');
    const cart = document.querySelector('cart-drawer');

    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    if (label) label.classList.add('hidden');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      config.body = formData;
      const response = await fetch(routes.cart_add_url, config);
      const state = await response.json();

      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || 'Unable to add this protection option.');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-protection' });
      }

      if (cart && typeof cart.renderContents === 'function' && state.sections) {
        cart.renderContents(state);
      } else {
        window.location.href = window.routes && routes.cart_url ? routes.cart_url : '/cart';
      }
    } catch (error) {
      if (errorNode) {
        errorNode.textContent = error.message || 'Unable to add this protection option.';
        errorNode.hidden = false;
      } else {
        console.error(error);
      }
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
      if (label) label.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    }
  });
})();
